export const RE_FLITCHING_HISTORY_REQUEST = "RE_FLITCHING_HISTORY_REQUEST";
export const RE_FLITCHING_HISTORY_SUCCESS = "RE_FLITCHING_HISTORY_SUCCESS";
export const RE_FLITCHING_HISTORY_FAILED = "RE_FLITCHING_HISTORY_FAILED";
